import React from "react";
import clsx from "clsx";
import AssetUtil from "../util/AssetsUtil";

import Logo from "../../../assets/images/svg-components/BALogo.svg";
import * as styles from "./styles/BALogo.css";

type BALogoProps = {
	colorType?:
		| "color"
		| "blue"
		| "white"
		| "cyan"
		| "red"
		| "yellow"
		| "transparentGray";
	className?: string;
	alt?: string;
};

export const BALogo: React.FC<BALogoProps> = ({
	colorType = "color",
	className,
	alt = "Beast Academy Logo",
}) => {
	if (colorType === "color") {
		const src = AssetUtil.getLogo("ba-color");
		return <img src={src} className={className} alt={alt} />;
	}

	// like the image parallel, if alt is falsy, we hide the logo from screen
	// readers.  Otherwise we include the relevant attributes.
	const a11yProps: Record<string, string> = {};
	if (alt) {
		a11yProps["aria-label"] = alt;
		a11yProps["role"] = "img";
	} else {
		a11yProps["aria-hidden"] = "true";
	}

	return <Logo className={clsx(styles[colorType], className)} {...a11yProps} />;
};
